import { render, staticRenderFns } from "./enCourseVideo.vue?vue&type=template&id=671a6d96&scoped=true"
import script from "./enCourseVideo.vue?vue&type=script&lang=js"
export * from "./enCourseVideo.vue?vue&type=script&lang=js"
import style0 from "./enCourseVideo.vue?vue&type=style&index=0&id=671a6d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671a6d96",
  null
  
)

export default component.exports